import styled, { css } from "styled-components";
import { IMessageProps } from "./types";
import { getThemeSpacers } from "commons/utils";

const MESSAGE_TYPE_COLORS: Record<
  NonNullable<IMessageProps["type"]>,
  string
> = {
  error: "#FFEDED",
  warning: "#FFF7E2",
  info: "transparent",
  success: "transparent"
};

export const Message = styled.div<IMessageProps>`
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  gap: ${getThemeSpacers("m")};
  padding: ${getThemeSpacers("xl")} ${getThemeSpacers("xl3")};
  border-radius: 12px;

  ${({ theme: { $status }, type = "info" }) => {
    const bgColor = MESSAGE_TYPE_COLORS[type];
    const iconColor = $status[type];

    return css`
      background-color: ${bgColor};

      svg {
        fill: ${iconColor};
      }
    `;
  }};
`;
